var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13.46 13.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#898a8d;}.cls-3{fill:#e1251b;}.cls-4{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.71,
    cy: 6.76,
    r: 4.39
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.72,4.71a1.59,1.59,0,0,1,.45-1.78L11,1.62A1.53,1.53,0,0,1,8.43.26L6.69,0C6.87,1.4,4.1,2.16,3.84.62l-1.49.91c1.3.9-.69,3.27-1.79,2.31L0,5.5c1.58-.16,1.7,3,.11,2.92L.75,10a1.27,1.27,0,0,1,1.83.27.51.51,0,0,0,.79-.64c-2.83-3,.35-8.36,4.42-7.16,3.67.79,4.48,6.12,1.28,8-.58.35,0,1.18.45.87a1.28,1.28,0,0,1,1.81.18l1.09-1.37a1.53,1.53,0,0,1,.9-2.78l-.05-1.75A1.54,1.54,0,0,1,11.72,4.71Z",
    transform: "translate(0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.39,5.1a3.5,3.5,0,0,0-1.1-1c-.24.63-.42,3.6-1.16,3.91L8.36,9.91A3.47,3.47,0,0,0,9.39,5.1Z",
    transform: "translate(0.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.43,6.76A6.73,6.73,0,1,0,4.17,13l.61-3.07c-2.69-1.81-1.6-6.4,1.67-6.73,0,1.1-1.7,4.67.3,4.94l1.16,2-.66,3.37A6.71,6.71,0,0,0,13.43,6.76Z",
    transform: "translate(0.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.75,8.13c-2-.27-.31-3.84-.3-4.94-3.27.33-4.36,4.92-1.67,6.73L4.17,13a7.55,7.55,0,0,0,1.14.36,10.29,10.29,0,0,0,.29-1.61.35.35,0,0,1,.69.13A8.84,8.84,0,0,0,6,13.45a6,6,0,0,0,.74,0l.54,0,.66-3.37Z",
    transform: "translate(0.02)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavMap);
export default __webpack_public_path__ + "static/media/fav-map.e9c1d9c8b7b9f69c628897ad426b71b3.svg";
export { ForwardRef as ReactComponent };